import {createSlice} from '@reduxjs/toolkit'


const chatbotInput = createSlice({
    name: 'chatbotInput',
    initialState: {
        //this state is shared between MultipleSelectInput.js (Search Input) and MultipleSelectOptions.js (Bot Message)
        selectedOptions: []
    },
    reducers: {
        resetSelectedOptions: (state, _) => {
            state.selectedOptions = []
        },
        setSelectedOptions: (state, action) => {
            state.selectedOptions = action.payload
        },
        addSelectedOptions: (state, action) => {
            state.selectedOptions = state.selectedOptions.concat(action.payload)
        },
        removeSelectedOptions: (state, action) => {
            state.selectedOptions = state.selectedOptions.filter(o => o.id !== action.payload).map(i => i)
        },
    }
})

export const {
    resetSelectedOptions,
    setSelectedOptions,
    addSelectedOptions,
    removeSelectedOptions
} = chatbotInput.actions

export default chatbotInput.reducer